module.exports = __webpack_public_path__ + "img/factory-icon.98ea44a9.svg";